import { observer } from "mobx-react";
import React, { useContext } from "react";

import { EventContext, LookupContext, SportOfferContext } from "@gp/components";

import TeamIcon from "@components/icons/TeamIcon";
import { TeamName } from "@features/offer/mobile/shared/common/TeamName";
import { RedCards } from "@features/offer/mobile/shared/common/RedCards";

export const Competitors = observer(function Competitors() {
	const { teams, tournaments } = useContext(LookupContext);
	const event = useContext(EventContext);
	const sport = useContext(SportOfferContext);

	const t1 = teams.get(event.teamOneId || "");
	const t2 = teams.get(event.teamTwoId || "");

	if (t1 == null || t2 == null) {
		console.error("Expected teams, got one or more null.");
		return null;
	}

	const tournament = tournaments.get(event.tournamentId);

	return (
		<div className="match__competitors">
			<div className="match__team">
				<TeamIcon
					showCountryFlag={tournament?.showCountryFlag}
					flagCode={t1?.countryCode}
					jerseyTypeAbrv={t1?.jerseyTypeAbrv}
					opponentFlagCode={t2?.countryCode}
					opponentJerseyTypeAbrv={t2?.jerseyTypeAbrv}
					className="match__team__flag u-icon--base"
				/>
				<TeamName name={t1.name} gender={t1.gender} />
				<RedCards
					sport={sport}
					statistics={event.result?.homeTeamTotalStatistics}
				/>
			</div>
			<div className="match__team">
				<TeamIcon
					showCountryFlag={tournament?.showCountryFlag}
					flagCode={t2?.countryCode}
					jerseyTypeAbrv={t2?.jerseyTypeAbrv}
					opponentFlagCode={t1?.countryCode}
					opponentJerseyTypeAbrv={t1?.jerseyTypeAbrv}
					className="match__team__flag u-icon--base"
				/>
				<TeamName name={t2.name} gender={t2.gender} />
				<RedCards
					sport={sport}
					statistics={event.result?.awayTeamTotalStatistics}
				/>
			</div>
		</div>
	);
});
